import { useState, FormEvent } from "react";

const ContactSection = () => {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const textarea = form.querySelector("textarea");
    if (textarea && textarea.value.length > 500) {
      alert("הודעה לא יכולה לעלות על 500 תווים");
      return;
    }
    setLoading(true);
    const data = new URLSearchParams(new FormData(form) as unknown as Record<string, string>);
    try {
      await fetch("https://readdy.ai/api/form/d7c64bgfgr5j5eoavjd0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="contact"
      aria-labelledby="contact-heading"
      className="py-20 bg-[#1a0a00]"
      dir="rtl"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left - Info */}
          <div>
            <span
              className="inline-block bg-[#e85d04]/20 text-[#f4a261] px-4 py-1.5 rounded-full text-sm font-semibold mb-6"
              style={{ fontFamily: "'Assistant', sans-serif" }}
              aria-hidden="true"
            >
              בואו נדבר
            </span>
            <h2
              id="contact-heading"
              className="text-white font-black text-4xl md:text-5xl mb-6 leading-tight"
              style={{ fontFamily: "'Assistant', sans-serif" }}
            >
              מוכנים להזמין
              <br />
              <span className="text-[#e85d04]">את העגלה לאירוע?</span>
            </h2>
            <p
              className="text-white/70 text-lg leading-relaxed mb-8"
              style={{ fontFamily: "'Assistant', sans-serif" }}
            >
              אנחנו מגיעים עם כל הציוד, הבשרים והצוות.
              אתם רק צריכים להביא את האורחים ואת התיאבון.
            </p>

            <address className="not-italic flex flex-col gap-4">
              <a
                href="tel:+972542465614"
                className="flex items-center gap-3 text-white/80 hover:text-[#e85d04] transition-colors duration-200 cursor-pointer"
                style={{ fontFamily: "'Assistant', sans-serif" }}
                aria-label="התקשרו אלינו: 054-246-5614"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-[#e85d04]/20 rounded-full" aria-hidden="true">
                  <i className="ri-phone-fill text-[#e85d04]" aria-hidden="true"></i>
                </div>
                <span className="text-lg font-semibold">054-246-5614</span>
              </a>
              <a
                href="https://wa.me/972542465614"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-white/80 hover:text-[#25d366] transition-colors duration-200 cursor-pointer"
                style={{ fontFamily: "'Assistant', sans-serif" }}
                aria-label="שלחו הודעה בוואטסאפ (נפתח בחלון חדש)"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-[#25d366]/20 rounded-full" aria-hidden="true">
                  <i className="ri-whatsapp-fill text-[#25d366]" aria-hidden="true"></i>
                </div>
                <span className="text-lg font-semibold">שלחו הודעה בוואטסאפ</span>
              </a>
              <a
                href="https://www.instagram.com/meet_n_meatoffical/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-white/80 hover:text-[#e85d04] transition-colors duration-200 cursor-pointer"
                style={{ fontFamily: "'Assistant', sans-serif" }}
                aria-label="עקבו אחרינו באינסטגרם @meet_n_meatoffical (נפתח בחלון חדש)"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-[#e85d04]/20 rounded-full" aria-hidden="true">
                  <i className="ri-instagram-fill text-[#e85d04]" aria-hidden="true"></i>
                </div>
                <span className="text-lg font-semibold">@meet_n_meatoffical</span>
              </a>
            </address>
          </div>

          {/* Right - Form */}
          <div className="bg-white/5 border border-white/10 rounded-2xl p-8">
            {submitted ? (
              <div className="text-center py-10" role="alert" aria-live="polite">
                <div className="w-16 h-16 flex items-center justify-center bg-[#e85d04]/20 rounded-full mx-auto mb-4" aria-hidden="true">
                  <i className="ri-check-line text-[#e85d04] text-3xl" aria-hidden="true"></i>
                </div>
                <h3
                  className="text-white font-bold text-2xl mb-2"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                >
                  תודה! קיבלנו את הפנייה שלכם
                </h3>
                <p
                  className="text-white/60"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                >
                  ניצור איתכם קשר בהקדם האפשרי
                </p>
              </div>
            ) : (
              <form
                data-readdy-form
                onSubmit={handleSubmit}
                className="flex flex-col gap-4"
                aria-label="טופס קבלת הצעת מחיר לאירוע"
                noValidate
              >
                <input type="hidden" name="_recipient" value="Lior.job@gmail.com" />
                <input type="hidden" name="_replyto" value="Lior.job@gmail.com" />
                <h3
                  className="text-white font-bold text-xl mb-2"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                >
                  קבלו הצעת מחיר לאירוע
                </h3>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label
                      htmlFor="contact-name"
                      className="text-white/70 text-sm mb-1 block"
                      style={{ fontFamily: "'Assistant', sans-serif" }}
                    >
                      שם מלא <span aria-label="שדה חובה">*</span>
                    </label>
                    <input
                      id="contact-name"
                      type="text"
                      name="name"
                      required
                      autoComplete="name"
                      placeholder="ישראל ישראלי"
                      aria-required="true"
                      className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white placeholder-white/30 text-sm focus:outline-none focus:border-[#e85d04] transition-colors"
                      style={{ fontFamily: "'Assistant', sans-serif" }}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="contact-phone"
                      className="text-white/70 text-sm mb-1 block"
                      style={{ fontFamily: "'Assistant', sans-serif" }}
                    >
                      טלפון <span aria-label="שדה חובה">*</span>
                    </label>
                    <input
                      id="contact-phone"
                      type="tel"
                      name="phone"
                      required
                      autoComplete="tel"
                      placeholder="050-000-0000"
                      aria-required="true"
                      className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white placeholder-white/30 text-sm focus:outline-none focus:border-[#e85d04] transition-colors"
                      style={{ fontFamily: "'Assistant', sans-serif" }}
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="contact-email"
                    className="text-white/70 text-sm mb-1 block"
                    style={{ fontFamily: "'Assistant', sans-serif" }}
                  >
                    כתובת מייל
                  </label>
                  <input
                    id="contact-email"
                    type="email"
                    name="email"
                    autoComplete="email"
                    placeholder="example@gmail.com"
                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white placeholder-white/30 text-sm focus:outline-none focus:border-[#e85d04] transition-colors"
                    style={{ fontFamily: "'Assistant', sans-serif" }}
                  />
                </div>

                <div>
                  <label
                    htmlFor="contact-event-type"
                    className="text-white/70 text-sm mb-1 block"
                    style={{ fontFamily: "'Assistant', sans-serif" }}
                  >
                    סוג האירוע <span aria-label="שדה חובה">*</span>
                  </label>
                  <select
                    id="contact-event-type"
                    name="event_type"
                    required
                    aria-required="true"
                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white text-sm focus:outline-none focus:border-[#e85d04] transition-colors"
                    style={{ fontFamily: "'Assistant', sans-serif" }}
                  >
                    <option value="" className="bg-[#1a0a00]">בחרו סוג אירוע</option>
                    <option value="חתונה" className="bg-[#1a0a00]">חתונה</option>
                    <option value="בר/בת מצווה" className="bg-[#1a0a00]">בר/בת מצווה</option>
                    <option value="אירוע חברה" className="bg-[#1a0a00]">אירוע חברה</option>
                    <option value="יום הולדת" className="bg-[#1a0a00]">יום הולדת</option>
                    <option value="מסיבת רווקים/ות" className="bg-[#1a0a00]">מסיבת רווקים/ות</option>
                    <option value="אחר" className="bg-[#1a0a00]">אחר</option>
                  </select>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label
                      htmlFor="contact-event-date"
                      className="text-white/70 text-sm mb-1 block"
                      style={{ fontFamily: "'Assistant', sans-serif" }}
                    >
                      תאריך מתוכנן
                    </label>
                    <input
                      id="contact-event-date"
                      type="date"
                      name="event_date"
                      className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white text-sm focus:outline-none focus:border-[#e85d04] transition-colors"
                      style={{ fontFamily: "'Assistant', sans-serif" }}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="contact-guests"
                      className="text-white/70 text-sm mb-1 block"
                      style={{ fontFamily: "'Assistant', sans-serif" }}
                    >
                      כמות משתתפים
                    </label>
                    <input
                      id="contact-guests"
                      type="number"
                      name="guests"
                      min="1"
                      placeholder="כמות משתתפים"
                      className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white placeholder-white/30 text-sm focus:outline-none focus:border-[#e85d04] transition-colors"
                      style={{ fontFamily: "'Assistant', sans-serif" }}
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="contact-location"
                    className="text-white/70 text-sm mb-1 block"
                    style={{ fontFamily: "'Assistant', sans-serif" }}
                  >
                    מיקום האירוע
                  </label>
                  <input
                    id="contact-location"
                    type="text"
                    name="location"
                    autoComplete="address-level2"
                    placeholder="עיר / כתובת"
                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white placeholder-white/30 text-sm focus:outline-none focus:border-[#e85d04] transition-colors"
                    style={{ fontFamily: "'Assistant', sans-serif" }}
                  />
                </div>

                <div>
                  <label
                    htmlFor="contact-message"
                    className="text-white/70 text-sm mb-1 block"
                    style={{ fontFamily: "'Assistant', sans-serif" }}
                  >
                    הודעה נוספת (עד 500 תווים)
                  </label>
                  <textarea
                    id="contact-message"
                    name="message"
                    rows={3}
                    maxLength={500}
                    placeholder="פרטים נוספים על האירוע..."
                    aria-describedby="message-char-count"
                    onChange={(e) => setCharCount(e.target.value.length)}
                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white placeholder-white/30 text-sm focus:outline-none focus:border-[#e85d04] transition-colors resize-none"
                    style={{ fontFamily: "'Assistant', sans-serif" }}
                  />
                  <p
                    id="message-char-count"
                    className="text-white/40 text-xs mt-1 text-left"
                    aria-live="polite"
                    style={{ fontFamily: "'Assistant', sans-serif" }}
                  >
                    {charCount}/500 תווים
                  </p>
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  aria-busy={loading}
                  className="bg-[#e85d04] hover:bg-[#d44d00] disabled:opacity-60 text-white py-4 rounded-full font-bold text-base transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                >
                  {loading ? "שולח..." : "שלחו פנייה ←"}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
